import React from 'react'
import Home from '../components/Home/Home'
import NavBar from '../components/NavBar/NavBar'

const Homes = () => {
  return (
    <div>
        <NavBar/>
         <Home />
    </div>
  )
}

export default Homes